export default __webpack_public_path__ + "static/media/sprkl.46d08789.jpg";